import { defineStore } from 'pinia';

import { type User } from '../models';

export const useUserStore = defineStore('user', {
    state: () => ({
        currentUser: null as User | null
    }),
    actions: {
        setCurrentUser(user: User): void {
            this.currentUser = user;
        },
        clearCurrentUser(): void {
            this.currentUser = null;
        }
    }
});